import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import Page from 'modules/app/components/Page';
// import useIsAuth from 'sdk/hooks/useIsAuth';
import EditForm from './EditForm';

function CreatePost() {
  const [activeFile, setActiveFile] = useState<string>('')

  return (
    <EditForm
      video={activeFile}
      setActiveFile={setActiveFile}
    />
  )
}

function CreatePostPage() {
  return (
    <Page activeLink="/community">
      <CreatePost />
    </Page>
  )
}

export default CreatePostPage
